import {
  RESET_DASHBOARD_PERFORMANCE_REQUESTED,
  RESET_DASHBOARD_PERFORMANCE_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_DASHBOARD_PERFORMANCE_REQUESTED,
  });

  dispatch({
    type: RESET_DASHBOARD_PERFORMANCE_COMPLETED,
  });
};

export default resetAction;
